import type { ReactNode } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export function Layout({ children, compact = false }: { children: ReactNode; compact?: boolean }) {
  const { user, logout, canManageObjects, isAdmin } = useAuth();
  return <div className={compact ? 'app compact' : 'app'}>
    {!compact && <header className="topbar">
      <Link className="brand" to="/"><span className="brand-mark">O</span><span>OpenAR</span></Link>
      {user && <nav><NavLink to="/library">Objecten</NavLink>{canManageObjects && <NavLink to="/admin">Beheer</NavLink>}{isAdmin && <NavLink to="/users">Gebruikers</NavLink>}<NavLink to="/settings">Instellingen</NavLink></nav>}
      {user ? <div className="account-menu"><span><strong>{user?.displayName}</strong><small>{user?.role === 'admin' ? 'Administrator' : user?.role === 'editor' ? 'Editor' : 'Gebruiker'}</small></span><button className="text-button" onClick={() => void logout()}>Uitloggen</button></div> : <Link to="/login">Inloggen voor beheer</Link>}
    </header>}
    {children}
  </div>;
}
